export default "__VITE_ASSET__DrLC_c0v__"